export const API_PATHS = {
  login: "/api/login",
  bitelRevenue: "/api/get-data-bitel",
  airtimeBitelRevenue: "/api/get-data-airtime-bitel",
  postAirtimeBitel: "/api/create-new-record-airtime-bitel",
  unitel: "/api/get-data-unitel",
  halotelRevenue: "/api/get-data-halotel",
  mytelRevenue: "/api/get-data-mytel",
  mytelMagicWheel: "/api/get-data-magicwheel",
  mytelErrorCode: "/api/get-data-error-code-auction-mytel",
  mytelVm: "/api/get-data-vm-mytel",
  postHalotel: "/api/create-new-record-halotel",
  getInfoRevenue: "/api/get-all-project",
  editProject: "/api/edit-project",
  bicagame: "/api/get-data-bicagame",
};
